import PropTypes from 'prop-types'
import { Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'

const SearchEmptyState = ({ onClearSearch }) => {
  const t = useTranslations()
  return (
    <>
      <Typography variant="h2" className={'decorator'}>
        {t('empty:no-results')}
      </Typography>
      <Typography sx={{ color: 'neutral.main' }}>
        {t('empty:try-another-search')}
      </Typography>
    </>
  )
}

SearchEmptyState.propTypes = {
  onClearSearch: PropTypes.func,
}

export default SearchEmptyState
